export const EDIT_CONTRIB_NOTIFICATION_KEY = 'acceslibre-contrib_edit_notification_id'
